import React from 'react';
import PropTypes from 'prop-types';
import { Alert } from 'react-bootstrap-5';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faExclamationTriangle } from '@fortawesome/pro-solid-svg-icons';

export function FailedDocumentsAlert({ documents }) {
  if (!documents?.length) return null;

  const groupedByError = documents.reduce((acc, doc) => {
    const msg = doc.errorMessage.trim();
    const name = doc.filename ?? `Document ${doc.uploadId}`;
    if (!acc[msg]) acc[msg] = [];
    acc[msg].push(name);
    return acc;
  }, {});

  return (
    <Alert className="mb-4" variant="warning">
      <div className="d-flex align-items-start gap-2">
        <FontAwesomeIcon className="flex-shrink-0 mt-1" icon={faExclamationTriangle} />
        <div>
          <strong>
            {documents.length} document{documents.length > 1 ? 's' : ''} could not be processed
          </strong>
          {Object.entries(groupedByError).map(([errorMsg, filenames]) => (
            <div className="mt-2 small" key={errorMsg}>
              {filenames.map(name => (
                <div className="fw-semibold text-break" key={name}>{name}</div>
              ))}
              <div>{errorMsg}</div>
            </div>
          ))}
        </div>
      </div>
    </Alert>
  );
}

FailedDocumentsAlert.propTypes = {
  documents: PropTypes.arrayOf(PropTypes.shape({
    uploadId: PropTypes.number.isRequired,
    filename: PropTypes.string,
    errorMessage: PropTypes.string.isRequired,
  })),
};
